import { IOfferCard } from '../../../../types';
import { isFromBuilder, isFromLeadFactory, isFromSeller } from '../../utils';
import { TContactType } from '@cian/contact-card-component';

export const prepareAvatarType = (offerCard: IOfferCard): TContactType => {
  const { isByHomeowner, offerUser } = offerCard;

  const fromBuilder = isFromBuilder(offerCard);
  const fromSeller = isFromSeller(offerCard);
  const fromLeadFactory = isFromLeadFactory(offerCard);

  switch (true) {
    case isByHomeowner:
      return 'homeowner';

    case !fromLeadFactory && fromBuilder:
    case !fromLeadFactory && !fromBuilder && fromSeller:
    case fromLeadFactory:
      return 'builder';

    case offerUser?.masterAgent || offerUser?.accountType === 'agency':
    case offerUser?.accountType === 'managementCompany':
      return 'agency';

    case offerUser?.accountType === 'specialist':
      return 'agent';

    case !!offerUser?.bank:
      return 'bank';

    default:
      return 'user';
  }
};
